import React from 'react';
import { Container } from 'react-bootstrap';
import '../../../assets/css/student/NgoScreen/BottomStates.css';

const BottomStats = () => {
  const stats = [
    { number: '3,200+', label: 'Students Helped' },
    { number: '956+',   label: 'NGOs Joined' },
    { number: '120+',   label: 'Cities Covered' },
    { number: '$150K+', label: 'Total Donated' },
  ];

  return (
    <div className="bstat-section">
      <Container>
        <div className="bstat-inner">
          {stats.map((stat, index) => (
            <div className="bstat-item" key={index}>
              <div className="bstat-number">{stat.number}</div>
              <div className="bstat-label">{stat.label}</div>
            </div>
          ))}
          <a href="#verification" className="bstat-cta-btn">
            Join the Mission →
          </a>
        </div>
      </Container>
    </div>
  );
};

export default BottomStats;